///<reference path="../../../components/baseClasses/employeeSectionBase.ts"/>
module Meevo.Plugins.Employee {
    'use strict';

    /**
    * Main Section of Employee 
    */
    export class MainSection extends Meevo.Components.BaseClasses.EmployeeSectionBase<Model.Employee> {

        private minutes: Array<number> = _.range(0, 135, 15);
        public pagingNumberRegExp = /^([1-9]|[1-9][0-9]|[1-9][0-9][0-9])$/;
        public employeeClientLinkDetails: any = '';
        public modalService: Components.Modal.IModalService;
        public learningTracks: Array<Model.ObjectStateDataDetail>;
        public defaultLearningTrack: Model.ObjectStateDataDetail;
        public defaultPriceLevel: Model.PriceLevelEnum;

        employeePhotoTempSave: any = undefined;

        get showCustomFields() {
            return Model.Guard.isSomething(this.model) && this.model.isLocationEmployee
                && this.customControls && this.customControls.length > 0;
        }

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Components.Logging.ILoggingService,
            dataService: Components.BaseClasses.IDataService,
            protected identityService: Components.Common.IIdentityService = null,
            noun: Model.NounEnum = null,
            appSettings: Components.Common.IAppSettings,
            asLocationId: number,
            sectionSecurityKey?: string,
            modalService?: Components.Modal.IModalService,
            protected employeeDetail?: Model.DataDetail,
            private context?: Meevo.Components.BaseClasses.IDataMaintenanceContext
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey);
            this._asLocationId = asLocationId;
            this.modalService = modalService;
        }

        private _asLocationId: number;
        private isPagingEnabled: boolean = false;

        createSectionModelInstance(postAdd: (data: any) => any): void {
            var params: any = !!this.employeeDetail ? { employeeId: this.employeeDetail.id } : {}
            this.dataService.getTemplate(this.baseEndpoint, null, null, params).then((data) => {
                this.model = data;
                this.model.isLocationEmployee = true; //this probably could go on the server for the template 
                const item = (this.model) as Model.Employee;
                if (Model.Guard.isSomething(item.employeeCategories))
                    item.employeeCategories = [];

                this.loadDefaultLearningTrack().then(res => {
                    this.model.learningTracks.push(this.defaultLearningTrack);
                });

                postAdd(data);
                this.getPagingSettings();
            });
        }

        createSectionModelCopy(): Model.Employee {
            const item = (this.model) as Model.Employee;
            item.id = null;
            return item;
        }

        activate(): void {
            // Initialize model properties
            this.model.locationSecurityRoleDetail = undefined;
            this.model.locationSmartCenterDetail = undefined;
            this.model.employeeCategoryDetail = undefined;
            this.initializeEmployee();
            this.getPagingSettings();

            if (!this.usersSettings && !this.defaultLearningTrack) {
                this.loadDefaultLearningTrack();
            }
            
            if (this.context["canLocationAddUser"] < 0) {
                this.modalService.alert("MESSAGE_USER_LIMIT_EXCEEDED_FREEUP");
            }

            super.activate();
        }

        postAdd(): void {
            super.postAdd();
            this.employeePhotoTempSave = this.model.meevoFile;
            this._IsEmployeeOriginal = this.model.isLocationEmployee;
        }

        postUpdate(): void {
            super.postUpdate();
            this.employeePhotoTempSave = this.model.meevoFile;            
        }

        private _IsEmployeeOriginal: boolean = false;

        initializeEmployee(): void {
            let employee = this.model;
            if (Model.Guard.isSomething(employee)) {
                this._IsEmployeeOriginal = employee.isLocationEmployee;

                if (Model.Guard.isNothing(employee.gender) || employee.gender == 0)
                    employee.gender = Model.GenderEnum.NotSpecified;

                if (Model.Guard.isSomething(employee.hireDate))
                    (employee as any).hireDate = moment(employee.hireDate).toDate();

                if (Model.Guard.isNothing(employee.hireDate))
                    (employee as any).hireDate = moment().toDate();

                if (Model.Guard.isNothing(employee.employeeAppointmentBookViewPreference) || employee.employeeAppointmentBookViewPreference == 0)
                    employee.employeeAppointmentBookViewPreference = Model.EmployeeAppointmentBookViewEnum.All;
                if (Model.Guard.isNothing(employee.defaultServicePriceLevel) || employee.defaultServicePriceLevel == 0)
                    employee.defaultServicePriceLevel = Model.PriceLevelEnum.Level1;
            }

        }


        employeeClientLinkDetailsLoad(): any {
            let employee = this.model;
            return this.employeeClientLinkDetails = {
                firstName: employee.firstName,
                lastName: employee.lastName,
                preFix: employee.prefix,
                middleName: employee.middleName,
                address: employee.address,
                email: employee.emailAddress,
                gender: employee.gender,
                birthDate: employee.birthDate != undefined ? moment(employee.birthDate) : undefined,
                phoneNumbers: [{ type: 22, number: employee.phoneNumber, countryCode: employee.countryCode, isPrimary: true }, { type: 21, number: employee.homePhoneNumber, countryCode: employee.countryCode }]
            };
        }

        preSave(): void {
            if (Model.Guard.isNothing(this.model.employeeEntityTypeEnum)) {
                this.model.employeeEntityTypeEnum = Meevo.Model.EmployeeEntityTypeEnum.Employee;
            }
            if (this.model.learningTracks.length === 0) {
                this.model.learningTracks.push(this.defaultLearningTrack);
            }
        }

        private _isPasswordRequired: boolean;
        private _passwordEntry: string;

        // isPasswordRequired

        get isPasswordRequired(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Adding || this._isPasswordRequired;
        }

        set isPasswordRequired(value: boolean) {
            this._isPasswordRequired = value;
        }

        // passwordEntry

        get passwordEntry(): string {
            return this._passwordEntry;
        }

        set passwordEntry(value: string) {
            if (this.mode === Meevo.Model.MaintenanceFormState.Editing && (value === undefined || value.length === 0)) {
                this.isPasswordRequired = true;
            }
            this._passwordEntry = value;
        }

        // Category Management

        get isCategoryRequired(): boolean {
            const employee = this.model;
            return Model.Guard.isSomething(employee) &&
                Model.Guard.isSomething(employee.employeeCategories) &&
                employee.employeeCategories.length === 0 &&
                employee.isLocationEmployee;
        }

        addEmployeeCategotry(): void {
            var employee = this.model;
            if (employee === null || Model.Guard.isNothing(employee.employeeCategoryDetail))
                return;
            if (employee.employeeCategoryDetail !== undefined &&
                _.find(employee.employeeCategories,
                    (ec) => {
                        return ec.displayName === employee.employeeCategoryDetail.displayName;
                    }) ===
                undefined) {
                {
                    employee.employeeCategories.push(employee.employeeCategoryDetail);
                    employee.employeeCategoryDetail = undefined;
                }
            }
        }

        removeEmployeeCategory(index: number): void {
            const employee = this.model;
            if (employee === undefined)
                return;
            employee.employeeCategories.splice(index, 1);
        }

        isSamePhoneNumber(employeeModel: Model.Employee): boolean {
            if (!!employeeModel) {
                if (Model.Guard.isNothing(employeeModel.phoneNumber) || Model.Guard.isNothing(employeeModel.homePhoneNumber))
                    return false;
                if (employeeModel.phoneNumber == employeeModel.homePhoneNumber && employeeModel.homeCountryCode == employeeModel.countryCode) {
                    return true;
                }
            }
            return false;
        }

        get isTerminated(): boolean {
            return this.modelIsSomething && Model.Guard.isSomething(this.model.terminatedDate);
        }

        get hasPromotion(): boolean {
            return this.modelIsSomething && this.model.isLocationEmployee && Model.Guard.isSomething(this.model.promotionId);
        }

        allowIsEmployeeChange(): boolean {
            return this.modelIsSomething && (this.mode === Meevo.Model.MaintenanceFormState.Adding || !this._IsEmployeeOriginal);
        }

        showSharedTab(): boolean {

            if (this.modelIsSomething && this.model.isLocationEmployee && Model.Guard.isNothing(this.model.employeeAppointmentBookViewPreference) || this.model.employeeAppointmentBookViewPreference == 0) {

                this.model.employeeAppointmentBookViewPreference = Model.EmployeeAppointmentBookViewEnum.All;
                this.model.defaultServicePriceLevel = Model.PriceLevelEnum.Level1;
            }

            return this.modelIsSomething &&
                (this.model.isShared || this.totalEmployeeLocationCount() === 1 || (this._IsEmployeeOriginal !== this.model.isLocationEmployee && this.totalEmployeeLocationCount() === 0)) &&
                this.identityService.inCentralOfficeMode() &&
                this.model.isLocationEmployee;
        }

        totalEmployeeLocationCount(): number {

            if (this.modelIsSomething)
                return 0;

            const numUl = Model.Guard.isSomething(this.model.security.userLocations)
                ? _.filter(this.model.security.userLocations, (item: Model.UserLocation) => item.location.isEmployee)
                    .length
                : 0;
            return numUl;
        }

        clientLinkUnlink(): void {
            this.model.employeeClientLinkDetail = null;
        }

        getLearningTracks(): ng.IPromise<any> {
            return this.dataService.getListPaged('MeevoStore/LearningTrack', {}).then((res) => {
                this.learningTracks = res;
                return res;
            });
        }

        setDefaultLearningTrack(learningTrackId) {
            let defaultTrackFromList = _.findWhere(this.learningTracks, { learningTrackId: learningTrackId });

            this.defaultLearningTrack = {
                id: defaultTrackFromList['learningTrackId'],
                displayName: defaultTrackFromList['displayName']
            };
            return this.defaultLearningTrack;
        }

        loadDefaultLearningTrack(): ng.IPromise<any> {
            return this.getLearningTracks().then(res => {
                return this.setDefaultLearningTrack(this.usersSettings.defaultLearningTrack);
            });
        }

        // Learning Tracks
        addLearningTrack(location: Model.UserLocation): void {

            if (Model.Guard.isNothing(location) || Model.Guard.isNothing(location.newAddLearningTrackDetail))
                return;

            if (_.any(this.model.learningTracks, (sr) => {
                return sr['id'] === location.newAddLearningTrackDetail['learningTrackId']
            }))
                return;

            var learningTrackDetail: Model.ObjectStateDataDetail = {
                id: location.newAddLearningTrackDetail['learningTrackId'],
                displayName: location.newAddLearningTrackDetail.displayName
            };
            this.model.learningTracks.push(learningTrackDetail);
            location.newAddLearningTrackDetail = undefined;
        }

        removeLearningTrack(location: any, index: number, item: any): void {

            if (Model.Guard.isSomething(this.model.learningTracks)) {
                var i = this.model.learningTracks.indexOf(item);

                if (i != -1) {
                    this.model.learningTracks.splice(i, 1);
                }
            }
        }

        // Paging property
        getPagingSettings(): void {
            this.dataService.getItem('Settings/PagingFields').then((data: any) => {
                let { pagingEnable } = data;
                this.isPagingEnabled = pagingEnable;
            });
        }

        checkEmailUseForAppointmentChk(emailAddress) {
            if (!this.model.isEmployeeEmailOptInEnabledDefault)
                return;

            if (emailAddress != "" && emailAddress != undefined)
                (this.model as any).isEmailCommStatusOptedIn = true;
            else
                (this.model as any).isEmailCommStatusOptedIn = false;
        }

        checkSMSOptInForTextChk(phoneNumber) {
            if (!this.model.isEmployeeSMSOptInEnabledDefault)
                return;

            if (phoneNumber != "" && phoneNumber != undefined)
                (this.model as any).isSmsCommStatusOptedIn = true;
            else
                (this.model as any).isSmsCommStatusOptedIn = false;
        }


        saveCustomControls(): void {
            if (this.model.isLocationEmployee) 
                super.saveCustomControls();              
        }

        onEnableTwoFactorChanged(event): void {
            event.stopPropagation();
            event.preventDefault();
            const options = {
                templateUrl: 'app/plugins/employee/modals/emp-two-factor.template.html',
                controller: 'meevo.components.empTwoFactorModal.EmpTwoFactorModalController',
                controllerAs: 'vm',
                bindToController: true,

                locals: {
                    headerText: 'Two-Factor Authentication',
                    userId: this.model.id,
                    isMfaEnabled: (<any>this.model).isMfaEnabled
                }
            };

            this.modalService.showCustom(options, 0, true)
                .then((response: any) => {
                    (<any>this.model).isMfaEnabled = response.isMfaEnabled;
                    (<any>this.model).entityVersion = response.entityVersion;
                }
                )
                .catch((res: any) => {

                });
        }

        rollbackChanges(): void {

            let model = <Model.Employee>this.model;

            if (this.employeePhotoTempSave) {
                model.meevoFile = this.employeePhotoTempSave;
                model.isStorageUpdated = false;
            }
            if (model && model.fileGuid) {
                const deleteJson = {
                    FileGuid: model.fileGuid,
                    LocationId: model.locationId,
                    ResourceType: Model.FileTypes['EmployeeImage'] as Model.FileTypes
                };

                this.dataService.deleteFile(`${this.model.meevoFile.config.endPoint}`, deleteJson);
            }
            super.rollbackChanges();
        } 
    }
}
